import React, { ReactNode } from 'react';
import { useTranslation } from 'react-i18next';
import styled from 'styled-components';
import { Language } from '~common/i18n';
import { SelectField } from '~admin/view/components/ui/form/fields/field-select.component';
import { TextField } from '~common/components/form/field-text.component';
import {
  TranslationField,
  TranslationFormData,
} from '~admin/view/components/ui/form/fields/field-translation.component';
import { Column } from '~common/components/column.component';
import { languageOptionEnumMapper } from '~common/components/select.helper';

export interface EventBaseFormData {
  eventName: TranslationFormData<string>[];
  eventDescription: TranslationFormData<string>[];
  eventLanguage: Language;
}

export const EventBaseDetails: React.FunctionComponent = () => {
  const { t } = useTranslation();

  return (
    <Container>
      <TranslationField
        name={'eventName'}
        label={t('createEvent.eventDetails.eventName')}
        render={(renderProps): ReactNode => <TextField {...renderProps} />}
      />
      <TranslationField
        name={'eventDescription'}
        label={t('createEvent.eventDetails.description')}
        render={(renderProps): ReactNode => <TextField multiline {...renderProps} />}
      />
      <SelectField
        name={'eventLanguage'}
        label={t('createEvent.eventDetails.eventLanguage.label')}
        options={languageOptionEnumMapper(
          Language,
          t,
          'createEvent.eventDetails.eventLanguage.enum',
        )}
      />
    </Container>
  );
};

const Container = styled(Column)`
  flex: 1 1 auto;
  border: 2px solid ${(props): string => props.theme.colors.gray.v3};
  border-radius: 16px;
  padding: 16px;

  & > :not(:first-child) {
    margin-top: 24px;
  }
`;



// WEBPACK FOOTER //
// ./view/components/details/event-details/event-base-details.component.tsx